import { useRef, useEffect } from "react";
import Typed from "typed.js";
import getTypedOptions from "../typedConstants";

function useTyped(strings = [], options = {}) {
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current) {
      new Typed(ref.current, {
        strings,
        ...getTypedOptions(options),
      });
    }
  }, []);

  return [ref];
}

function useTypedOnScroll(strings = [], options = {}) {
  const ref = useRef(null);

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        new Typed(ref.current, {
          strings,
          ...getTypedOptions(options),
        });
      }
    },
    { threshold: 1 }
  );

  useEffect(() => {
    if (ref.current) {
      observer.observe(ref.current);
    }
  }, []);
  return [ref];
}

export { useTyped as default, useTypedOnScroll };
